import Navbar from "../../Components/Landing Page/NavBar";
import Hero from "../../Components/Landing Page/Hero";
import ImageGrid from "../../Components/Landing Page/Companys";
import Banner from "../../Components/Landing Page/Banner";
import Features from "../../Components/Landing Page/features";
import StageoneNew from "../../Components/Landing Page/StageoneNew";
import ReviewComponent from "../../Components/Landing Page/Reviews";
import ProductComparison from "../../Components/Landing Page/Comparision";
import ContactForm from "../../Components/Landing Page/contact_form";
import FAQ from "../UseCases/UseCaseFAQ";
import React, {useState} from "react";
import Modal from "../../Components/Modal";
import OfferModal from "../../Components/OfferModal";
import NavbarOffer from "../../Components/Landing Page/NavBarOffer";

function PricingComparison() {
    return null;
}

const EventOffer = () => {
    const [open, setIsOpen] = useState(true)

    const handleClose = () => {
        setIsOpen(false)
        document.body.style.overflow = 'unset';
    }


    return (
        <>
            <NavbarOffer/>
            <Hero/>
            <ImageGrid/>
            <Banner/>
            <Features/>
            <StageoneNew />
            <ReviewComponent/>
            <PricingComparison/>
            <ProductComparison />
            <OfferModal handleClose={handleClose} isOpen={open} />
        </>
    )
}

export default EventOffer